
import dayjs from "dayjs";
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import { Table } from "@common/src/utils/decorator";
import { addCurrencyUnit, addCurrencySymbol } from "@common/src/utils/tools";
import t from "@common/src/i18n/t";
const finance = namespace("finance");
const base = namespace("base");
@Component({})
@Table("loadListData")
export default class InvoiceManage extends Vue {
  @finance.Action getReceiptList;
  @base.Action getDictionaryList;
  dayjs = dayjs;
  splitThousands = splitThousands;
  emptyToLine = emptyToLine;
  addCurrencyUnit = addCurrencyUnit;
  addCurrencySymbol = addCurrencySymbol;
  searchForm = {
    receiptTimeFrom: "",
    receiptTimeTo: "",
    payerName: "",
    receiptNo: "",
    receiptType: ""
  };
  receiptList: any[] = [];
  receiptTypeList: any[] = [];
  get searchList() {
    return [
      {
        label: t("finance.receipt-time"),
        type: "timerange",
        value: "",
        prop: "receiptTime"
      },
      {
        label: t("finance.payer"),
        type: "input",
        value: "",
        prop: "payerName"
      },
      {
        label: t("finance.receipt-no"),
        type: "input",
        value: "",
        prop: "receiptNo"
      },
      {
        label: t("finance.proceeds-type"),
        type: "select",
        selectList: this.receiptTypeList,
        value: "",
        prop: "receiptType"
      }
    ];
  }

  created() {
    this.init();
  }
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        if (item.prop === "receiptTime") {
          this.searchForm.receiptTimeFrom = item.value ? item.value[0] : "";
          this.searchForm.receiptTimeTo = item.value ? item.value[1] : "";
        } else {
          this.searchForm[item.prop] = item.value;
        }
      }
    });
    this.loadListData();
  }
  totalReceiptAmount: string = "";
  @Table.LoadDataMethod()
  loadListData() {
    return this.getReceiptList({
      orderItems: this.mix_sortParams,
      ...this.searchForm,
      pageSize: this.mix_pageSize,
      pageNum: this.mix_pageNum
    }).then(data => {
      this.totalReceiptAmount = this.$safeValue(data, "data.totalReceiptAmount");
      this.receiptList = this.$safeValue(data, "data.list", []);
      return data;
    });
  }

  handleLinkView(row) {
    const { href } = this.$router.resolve(`/finance/collection-order-view/${row.receiptNo}`);
    window.open(href);
  }
  init() {
    this.loadListData();
    this.getDictionaryList("receipt_type").then(data => {
      this.receiptTypeList = data;
    });
  }
  handleInvoice(row) {
    this.$router.push(`/service/make-invoice/${row.receiptNo}`);
  }
  // -----------------------------
}
